/** True when `thread` is the chat currently open. A thread for another contact is ignored. */
export function threadMatchesContact(thread, contactId) {
  if (!contactId || !thread) return false;
  const loadedId = thread.contact?.contact_id;
  if (loadedId && String(loadedId) !== String(contactId)) return false;
  return true;
}

/**
 * Lead id to attach to a reply.
 * Keeps the picked lead when it is on this chat.
 * Otherwise uses the first lead on this chat, or '' when the chat has none.
 */
export function leadIdForThread(leads, pickedLeadId) {
  const list = Array.isArray(leads) ? leads.filter((lead) => lead && lead.id) : [];
  if (pickedLeadId != null && pickedLeadId !== '') {
    const match = list.find((lead) => String(lead.id) === String(pickedLeadId));
    if (match) return match.id;
  }
  return list[0]?.id || '';
}
